module.exports = __webpack_public_path__ + "static/media/Catanzaro.37bcba5a.png";